import { fillArr } from '@hglobal/fin-ui';

import { Rate } from '@iw/core/entities';

const rates = [
  { from: 'EUR', to: 'USD', rate: '1.03' },
  { from: 'USD', to: 'EUR', rate: '0.97' },
  { from: 'UAH', to: 'USD', rate: '0.024' },
  { from: 'KZT', to: 'EUR', rate: '0.0016' },
  { from: 'INR', to: 'USD', rate: '0.011' },
];

export function getRatesMock(count = 6): Rate[] {
  const now = new Date().toISOString();

  return fillArr(count, (i) => {
    const { from, to, rate } = rates[i % rates.length];

    return {
      id: `${i + 1}`,
      from,
      to,
      rate,
      createdAt: now,
      updatedAt: now,
    };
  });
}
